"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Legal = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Container = require("../Container");

var _Icons = require("../Icons");

var _styles = require("./styles");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  text: _propTypes.array,
  subLinks: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    href: _propTypes.string
  }))
} : {};

var Legal = function Legal(_ref) {
  var text = _ref.text,
      subLinks = _ref.subLinks;
  return (0, _core.jsx)(_styles.Wrapper, {
    "data-testid": "legal"
  }, (0, _core.jsx)(_Container.Container, null, (0, _core.jsx)(_styles.ContentBetween, null, (0, _core.jsx)(_styles.Stamp, null, (0, _core.jsx)(_styles.SeloAbcd, null), (0, _core.jsx)(_styles.StampDescription, null, "Fazemos parte da ABCD e atendemos \xE0s Orienta\xE7\xF5es de Conduta em nosso C\xF3digo de \xC9tica e Autorregula\xE7\xE3o.")), (0, _core.jsx)(_styles.SocialMedia, null, (0, _core.jsx)(_styles.SocialMediaItems, {
    gaAction: "social",
    "aria-label": "Facebook",
    target: "_blank",
    href: "https://www.facebook.com/creditasbr"
  }, (0, _core.jsx)(_Icons.Facebook, null)), (0, _core.jsx)(_styles.SocialMediaItems, {
    gaAction: "social",
    "aria-label": "Twitter",
    target: "_blank",
    href: "https://twitter.com/Creditas_Br"
  }, (0, _core.jsx)(_Icons.Twitter, null)), (0, _core.jsx)(_styles.SocialMediaItems, {
    gaAction: "social",
    "aria-label": "Instagram",
    target: "_blank",
    href: "https://www.instagram.com/creditasbr/"
  }, (0, _core.jsx)(_Icons.Instagram, null)), (0, _core.jsx)(_styles.SocialMediaItems, {
    gaAction: "social",
    "aria-label": "Linkedin",
    target: "_blank",
    href: "https://www.linkedin.com/company/creditasbr"
  }, (0, _core.jsx)(_Icons.Linkedin, null)))), (text == null ? void 0 : text.map) && (0, _core.jsx)(_styles.OnlyText, null, text.map(function (paragraph, index) {
    return (0, _core.jsx)("p", {
      key: "paragraph".concat(index)
    }, paragraph);
  })), (0, _core.jsx)(_styles.WrapperSubLinks, null, (subLinks == null ? void 0 : subLinks.map) && (0, _core.jsx)(_styles.SubLinks, null, subLinks.map(function (_ref2, index) {
    var label = _ref2.label,
        href = _ref2.href;
    return (0, _core.jsx)(_styles.SubLinksItems, {
      href: href,
      key: "SubLinkItems".concat(index),
      gaCategory: "copyright"
    }, label);
  })), (0, _core.jsx)(_styles.ComodoSecure, null, (0, _core.jsx)("source", {
    srcSet: "https://assets.creditas.com/website-assets/images/1.0.0/footer/comodoSecureBadge.webp"
  }), (0, _core.jsx)("img", {
    src: "https://assets.creditas.com/website-assets/images/1.0.0/footer/comodoSecureBadge.png",
    width: "84",
    height: "48",
    alt: "Selo do Comodo Secure",
    loading: "lazy"
  })))));
};

exports.Legal = Legal;
process.env.NODE_ENV !== "production" ? Legal.propTypes = propTypes : void 0;
Legal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Legal",
  "props": {
    "text": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "subLinks": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "label": {
              "name": "string",
              "required": false
            },
            "href": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": ""
    }
  }
};